import React from "react";
import PropTypes from 'prop-types';
import QuestionDefinition from "./QuestionDefinition";
import { ProgressSurveyQuestion } from "../utils/types";
import css from "./QuestionDefinitionsList.css";

export default class QuestionDefinitionsList extends React.Component {

  get surveyQuestions() {
    return (
    this.props.surveyQuestions
      .filter(({ type }) => type !== "default")
      .map(({name, category, description, studentView, id}) =>
        <QuestionDefinition key={id}
          name={name} category={category} description={description}
          studentView={studentView}/>
    ))
  }

  render() {
    return (
      <div className={css['container']}>
        <div aria-label={"Column Headers"} className={css['header']}>Column Headers</div>
        <ul>
          {this.surveyQuestions}
        </ul>
      </div>
    )
  }
}

QuestionDefinitionsList.propTypes = {
  surveyQuestions: PropTypes.arrayOf(ProgressSurveyQuestion)
}
